export default __webpack_public_path__ + "static/media/invention.03d1c773.svg";